import { create } from 'zustand';

export interface ConfirmOpts {
  title?: string;
  body: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
}

interface Pending extends ConfirmOpts {
  resolve: (ok: boolean) => void;
}

interface ConfirmState {
  current: Pending | null;
  /** Open a confirm dialog; resolves true on confirm, false on cancel/dismiss. */
  ask: (opts: ConfirmOpts) => Promise<boolean>;
  answer: (ok: boolean) => void;
}

export const useConfirmStore = create<ConfirmState>((set, get) => ({
  current: null,
  ask: (opts) =>
    new Promise<boolean>((resolve) => {
      // If one is already open, reject the old one first.
      get().current?.resolve(false);
      set({ current: { ...opts, resolve } });
    }),
  answer: (ok) => {
    const cur = get().current;
    if (!cur) return;
    cur.resolve(ok);
    set({ current: null });
  },
}));

/** Imperative helper usable from anywhere (handlers, stores). */
export const confirm = (opts: ConfirmOpts): Promise<boolean> => useConfirmStore.getState().ask(opts);
